  
<template>
  <header>
    <div class="hpHeader row">
       <div class="content col-sm-12">
             <div id="goHomeButton" class="logo">
                <img class="logoImage" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAFpOLgnAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA2ppVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDE0IDc5LjE1Njc5NywgMjAxNC8wOC8yMC0wOTo1MzowMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo3MzI2RDY2MTBFMjA2ODExODIyQUM5NDAzNzhCOTdCMCIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDo1RUNGNTc4MjNGQTMxMUU3QjNFQUE3NkJCQjNCMThDQSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo1RUNGNTc4MTNGQTMxMUU3QjNFQUE3NkJCQjNCMThDQSIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ1M2IChXaW5kb3dzKSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOmQ1MjcyMTM4LWRkOGQtMWQ0MS1hNWY3LTE5OWQyN2Q2NzI2OSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo3MzI2RDY2MTBFMjA2ODExODIyQUM5NDAzNzhCOTdCMCIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PnfSvhAAAAhMSURBVHjaYvz//z8DLsACIhinXwep0ALia3CZLC1GBrDOadewameCs0AKpl07jMxnBOlkZGQEcUKBQquAOBGI54OMZYHrgtmDbAWKa6ddm4psJ0AAMeLzCsJIiIP+Q1yJ7nyIfRdZ4BwI0AAK/oYECET7VHSjGVHsQDYOTeVBGBMggBChAJFoBZJVGB5mYPgFFGNH1TT9OkQxthBCB0B5WGQgazAFsrbC3YdOT7s2iwXJjAdQ+hTcNlQ6DSqvDnPeLyCHFUvAmgFZJ9HFYYHNhhaE96H0SWzBCRBABCIbEzBiJAaIk5KBvDlIMlxA8e+YSRgB5qAZ/A0oX4rQgFC8BY9rumAmVyGnRyQbF0FTHIqTQTa0Yk3UDAyxQHezAvmJQNyOkoGhIAyHU+ZBA+I1qqeztFYjhZI5Fv+IwGy4CsTaaJInoBptgWwpzHjAlmKxp2QVmJPi0CTCcCT3u4xIoWMEJM/iMP0mUEwDV1mhAKW/gIMUDQAEEGrWxW5ANZC8A7RhJQ7/gspSV6D8M5wJFqsl0679AJKw8uAR0AB5qPg/jESOCeKB6hfhtgTVcAa0ImEikMwjIcfpAfVeRk2F2AsqTiQ2SB5kkTEQ2yCJT8SizwmIL4HKKqBF6bCiB5sFbUAF1Rj1CoQ/F0gmAXE4UGwVDjVnoA5SZMLh1T9IFrxG8dW0awJQCx4iWfAPzQIzqAUgcIwJR8JmhSpOheY9kK9+QGXfQ9XAku0EaGKIQDIBueDlw2aJOhJ7Fpqv3qD5ih9I5kNTIK4knguLeEkgfg7Em4CKb6GFMcxXoDpEGIhb4L7K0vqIkqSnXbuBZsFvoJr5yK0JTnB5jB/8QbL0NawYwwHgRQRmZpx2rQJItuOqc5Hiaha+upn4YmXaNVDNkwzlqQE138YR7qB6QxNUEmIzBiCASK44yQH4y6Fp18SB5B6gC3Wh/JVYyvMKoHwnLiNAnmDCYTgnEIMaIC/ALRb8FUYHtPptwmURExYLYqGpDNbCSYWKyxMIlVqgmu+ELYGkrEVoKeUflLWDiODnwFbQMqFVi+hJF7lo1yA6ptF8hOyTs1jS+2SoJm8SExQHchzBugjzsCj8hMS2gdYboHjKQhK/B8SbMSxgYEgHxxEDQx3+dgoDgwPQJwfxdjIYGMSAal7jUVPxP1OzE9QBUcRRNBxEayHmY1HzGqpmGVSNI0byhsZJJRYrTiOxW6EGToQa6I+lsRsJVbMfqYWDEvFeWCzxhipmxRI/q6B0GlSNLJR/DklNC7ol0jiDgYFhKZT2Q5Jlg6qBxctOKO2F5jAUS36iic1GYoeixU8tlvyjCVXzEs1hKJacRhNLR2l6oso34cg/8zAchmbJArSgIhQMyPGzBq18U8RedmVpzUXi5yCx1aCWwhoPy6C0D5KaTHDnH1G+7cTSToa3IP+A2VlaU9GSKXL8hEAtPYzk6wVImQ+UylTRLHFFzvEKSH1PfADUGzbHU0owoHfiEZVWlhaoS32LCEu8cSVTLEAAsxTO0lInqA0RP0uJ6D58x15pYYx0oIBZ+JIpEihD758w4Wgz3cCiOQNfMkXqk3QTruMhFoFysTK0PYUr/6D6EuQ4aKcH61gaDovuwcupadf0kGRUoe3mLdDW/gNCUQkQoFurB40iCsJrFTAINkZj4x8Wno0SoyiiWKUIx4FgYxACagJyCCocGIhiFE+xUdQFIaJisEkhxHBiZYKIKQS1eRCsBEOMVSxSRFM4s/t2d97s7L537qVxYBfubva9N3szb77v27UTU/e+3g4TLrHveokMsKR3i68BTva8D3C8dVmkzYIY/imQEIJdg+Okbvu4wE00azV1+aFbvov9CaRJ1GwyIHVrAvHVHt0Tdwq/HoPJp5g/fj5a4EbPBtWYka/NB+KrGpxv54xTh8mG2DVDKU2rmNWkCncLxFd9cB6zTPARJuhm13UzqtFKS2k22YH4aq3G3TYAvxLIchShhi1mDo4Nq0gMMeX20npMEzlf7dCChgsL6RNg9tgqBxFpJYt6rcL266vOQPLhMrhsoxDE2SZ2OcRPL4Wecj5GiPYxMG0uwXGH7HJbUY80U8tXqO6WHIbEYLeRDonXdjBW8C2mD9mbxiT4lJkPAslD5Jsv4POJ+TwjGrGC33djDBFVPOMYBFqPEURo0yQdV1IsJKydGqOhJ5jPOjh/JnLndzi2CLIzFbpLWn5+EtVIv2MQmAqzbPB7rKawdn6y615oGc6LqVQiMkY2wTTbHgLfvRx81E/B1j6HICZT+eyrMqNao7GsmvgMxDQg0X+nmc/lgMcndgF8FPO5H3MY07poIG2WIH6xxUQQZJzVzgDzQRj7yKDrkRqb+HQFwSXWAJ+7wg2rZqytnQYyZwmkDIMvC6nQZqmdN6zv9Aq102C1w2/YekJHJZungTRyHG8YzDARMo5Q3VqonYcMl2X1nQ7yuWIAz9BexVA/K+VJILdymOcwW+ABJpag1v6A+VSYECbVzmmmlNYF4DnsmQ9nJLvJGyIHepgKnYR8RqkwT3YgrJ2NRtqFqbBA7iLyje1C2tkaICLnKYtXoEGnsZavngbALLTXAvjDpkdB4rhH355I9OhdBqSIno6YSrDEU9YEzdbzjkdFnEu+z5UG80Bj8jJBcavG6oy5jVYLjnsdxr1ih/EhiZpx2JbzDGunImyjEwXGxCa6n5MtO7Gyk6osW9TUd5n1nYUCNyeTXLlT3ZBkPW5iEYdh0vdsjHcOO5D0DwxKZKqY+BA+dcQt8WJOUCMw8VVhGx1xXPxvnQV1oae0WEVJFrhZo9FTGj3jSx0Hhb4zkzMK7np4x5/nvevgFMj/YH8BYZKacwP4XWgAAAAASUVORK5CYII="/> 
                <div class="logoName">{{title}}</div>
             </div>
       </div>
    </div>
  </header>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    }
  },
  data() {
    return {};
  }
};
</script>
<style scoped>

.hpHeader {
  width: 100%;
  height: 50px;
  margin: 0px 0px 15px 0px;
  padding: 11px 0;
  padding-top: 11px;
}
.content {
  height: 48px;
   display: flex;
   justify-content: space-between;
   color: #000;
   font-size: 28px;
}


.logo {
   position: relative;
   display: inline-flex;
   padding-right: 37px;
 }
 .logoImage {
   width: 50px;
   height: 50px;
   margin-right: 15px;
 }
 .logoName {
   margin: auto;
  margin-left: 10px;
   color: #000;
   font-size: 25px;
   font-family: "FormaDJR";
/* 
  font-family: "hpSimplifiedBold,Arial,Helvetica,sans-serif"; */
 }

img {
  width: 50px;
  height: 50px;
}
</style>